module.exports = __webpack_public_path__ + "static/media/seal-shp-190x190@2x.88995719.png";